module.exports = __webpack_public_path__ + "img/template3.1783bfbe.png";